/* ============================================================
   D&V Market — JavaScript global
   - Sticky header con sombra al scroll
   - Drawer del menú móvil
   - Drawer del carrito (estructura — el render se completa en Etapa 5)
   - Utilidades de focus trap y accesibilidad
   ============================================================ */

(function () {
  'use strict';

  /* ---------- Sticky header con sombra al scroll ---------- */
  const header = document.querySelector('.header-wrapper');
  if (header) {
    let lastScroll = 0;
    const onScroll = () => {
      const y = window.scrollY;
      if (y > 8) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
      lastScroll = y;
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Drawer genérico (menú móvil + carrito) ---------- */
  const overlay = document.getElementById('drawer-overlay');

  const openDrawer = (drawer) => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay?.classList.add('is-open');
    document.body.classList.add('drawer-open');

    // Focus en el primer elemento interactivo del drawer
    const focusable = drawer.querySelector('button, a, input, [tabindex]');
    focusable?.focus();
  };

  const closeAllDrawers = () => {
    document.querySelectorAll('.drawer.is-open').forEach((d) => {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    overlay?.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
  };

  // Triggers: cualquier elemento [data-drawer-open="ID"]
  document.querySelectorAll('[data-drawer-open]').forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const id = trigger.getAttribute('data-drawer-open');
      openDrawer(document.getElementById(id));
    });
  });

  // Cerrar: cualquier elemento [data-drawer-close] o el overlay
  document.querySelectorAll('[data-drawer-close]').forEach((btn) => {
    btn.addEventListener('click', closeAllDrawers);
  });
  overlay?.addEventListener('click', closeAllDrawers);

  // ESC para cerrar
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAllDrawers();
  });

  /* ---------- Smooth scroll para anchors internos ---------- */
  document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach((a) => {
    a.addEventListener('click', (e) => {
      const id = a.getAttribute('href');
      const target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  /* ---------- Helper global para formatear quetzales (GTQ) ---------- */
  window.DV = window.DV || {};
  window.DV.formatMoney = (cents) => 'Q' + (cents / 100).toLocaleString('es-GT', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  /* ---------- PROTECCIÓN BÁSICA DE IMÁGENES ----------
     Disuade el robo casual de imágenes: bloquea click derecho sobre
     imágenes, arrastrar imágenes, y la selección/long-press.
     NOTA: NO es seguridad real (no impide screenshots ni ver el código).
     La protección de fondo es la marca de agua en las imágenes. */
  function initImageProtection() {
    // 1. Bloquear menú contextual SOLO sobre imágenes (no en todo el sitio,
    //    para no molestar al copiar texto, links, etc.)
    document.addEventListener('contextmenu', (e) => {
      if (e.target && e.target.tagName === 'IMG') {
        e.preventDefault();
      }
    });

    // 2. Bloquear arrastrar imágenes al escritorio
    document.addEventListener('dragstart', (e) => {
      if (e.target && e.target.tagName === 'IMG') {
        e.preventDefault();
      }
    });
  }
  initImageProtection();
})();
